export default "__VITE_ASSET__B7eV6OWE__"